import { z } from 'zod'
import { api } from '@/lib/api/client'
import type { UserPresenceEntry } from '@/types/presence'

/**
 * Vocabulário FECHADO no back (`Literal['online','afk','offline']` em
 * `app/domains/company/users/models/model.py`), mas lido com `.catch(null)`:
 * estado novo do back não pode derrubar a lista inteira, e também não pode
 * virar "Offline" — a UI esconde a linha quando o status é `null`, e omitir é
 * honesto onde afirmar seria mentira.
 */
const PresenceStatusSchema = z.enum(['online', 'afk', 'offline'])

export const UserPresenceEntrySchema = z
  .object({
    db_id: z.string(),
    presence_status: PresenceStatusSchema.nullable().catch(null),
    /** Epoch em SEGUNDOS. `null` = nunca conectou. */
    last_seen_at: z.number().nullable().catch(null),
  })
  .passthrough()

const UserPresenceListSchema = z.array(UserPresenceEntrySchema)

/**
 * `GET /users/presence` — exige `users:presence:read`. 403 é ausência de grant,
 * e quem degrada isso pra vazio é o hook (`usePresenceSnapshot`), não este
 * módulo: aqui o erro sobe tipado (`ApiError`, posto pelo interceptor do `api`).
 */
export async function fetchPresence(): Promise<UserPresenceEntry[]> {
  const { data } = await api.get<unknown>('/users/presence')
  return UserPresenceListSchema.parse(data)
}
